import { useTranslation } from 'react-i18next';
import { AutocompleteOption, AutoCompleteMultiSearch } from '@bloomays-lib/ui.shared';

export const MISSION_SEARCH_MIN_LENGTH = 3;
export const MISSION_SEARCH_DEBOUNCE_MS = 300;

export type MissionOption = AutocompleteOption & {
  clientSocietyRecordId?: string;
  clientBillingSocietyRecordId?: string;
};

export type MissionSearchAutoCompleteProps = {
  label: string;
  placeholder: string;
  value: MissionOption[];
  disabled: boolean;
  onChange: (missions: MissionOption[]) => void;
  collectMissions: (input: string) => Promise<MissionOption[]>;
  loading: boolean;
};

export const MissionSearchAutoComplete = ({
  label,
  placeholder,
  value,
  disabled,
  onChange,
  collectMissions,
  loading,
}: MissionSearchAutoCompleteProps) => {
  const { t } = useTranslation(['purchaseOrderDashboard']);

  return (
    <AutoCompleteMultiSearch
      label={label}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      loading={loading}
      onChange={onChange}
      collectOptions={collectMissions}
      minSearchLength={MISSION_SEARCH_MIN_LENGTH}
      debounceMs={MISSION_SEARCH_DEBOUNCE_MS}
      noOptionsTextTooShort={t('formMissionMinSearchLength', { count: MISSION_SEARCH_MIN_LENGTH })}
    />
  );
};

export default MissionSearchAutoComplete;
